// extracted by mini-css-extract-plugin
export default {"wrapper":"MainCabinetPage_wrapper__0geQW","navList":"MainCabinetPage_navList__FImja","navItem":"MainCabinetPage_navItem__stKCr"};